import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface PropertyWithinPipeOption {
  replaceKey: string;
  value: any;
}
@Pipe({
  name: 'propertyWithin',
})
export class PropertyWithinPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(tranlatedText: string, options: PropertyWithinPipeOption[]): SafeHtml {
    const fragments = tranlatedText.split(' ');

    options.forEach((option) => {
      const propertyIndex = fragments.findIndex((entry) => entry === option.replaceKey);
      fragments[propertyIndex] = option.value;
    });

    const newText = fragments.join(' ');

    return this.sanitizer.bypassSecurityTrustHtml(newText);
  }
}
